export default "__VITE_ASSET__DKAgSwYn__"